import { String } from './string';
import { DecorativeBorder } from './DecorativeBorder';

interface Props {
  text: string;
  venueTitle: string;
}

export default function TextBlockWithBorders({ text, venueTitle }: Props) {
  if (!text) return <div className="pt-6" />;
  return (
    <div className="p-6 max-w-md mx-auto">
      <DecorativeBorder top />
      <p
        data-testid="venue-booking-text"
        className="leading-[1.4rem] text-white text-center italic font-light"
      >
        <em>
          <String id={text} /> {venueTitle}!
        </em>
      </p>
      <DecorativeBorder />
    </div>
  );
}
